import { render, staticRenderFns } from "./PaginaPerfilUsuario.vue?vue&type=template&id=fd262306"
import script from "./PaginaPerfilUsuario.vue?vue&type=script&lang=js"
export * from "./PaginaPerfilUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports